<template>
	<tooltip
		tooltip-wrapper-class-name="tool-tip__wrapper--relative tool-tip__wrapper--orientation"
		:content="orientationText"
		hover
		v-if="orientationSvg">
		<div
			class="orientation tool-tip__arrow-hook"
			v-html="orientationSvg"/>
	</tooltip>
</template>

<script>
import tooltip from "@/components/element/tooltip";

export default {
	name: "Orientation",
	components: {
		tooltip
	},
	props: {
		orientation: {
			type: Number,
			default: 0
		}
	},

	computed: {
		orientationName () {
			return this.$store.getters.getDictionary.orientation[this.orientation].toLowerCase();
		},
		orientationText () {
			const orientationName = orientation => ({
				"both": "staand en liggend",
				"portrait": "staand",
				"landscape": "liggend"
			})[orientation];

			const text = `${!this.getViewPort.m ? "dit formaat is " : ""}${orientationName(this.orientationName)} mogelijk`;

			return text && text[0].toUpperCase() + text.slice(1);
		},
		orientationSvg () {
			return this.$store.getters.getSvg.orientation[this.orientationName];
		},
		getViewPort () {
			return this.$store.getters.getViewPort;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/element/orientation.vue